// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "#articleContentTabs-nav {\n  padding-top: 0;\n}\n", "",{"version":3,"sources":["/home/jenkins/agent/workspace/helpcenter-release/client/src/components/article-content-tabs/article-content-tabs.less","article-content-tabs.less"],"names":[],"mappings":"AAAA;EACE,cAAA;ACCF","file":"article-content-tabs.less","sourcesContent":["#articleContentTabs-nav {\n  padding-top: 0;\n}\n","#articleContentTabs-nav {\n  padding-top: 0;\n}\n"]}]);
// Exports
module.exports = exports;
